import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=68ed8e42&scoped=true&"
import script from "./NewsAdd.vue?vue&type=script&lang=js&"
export * from "./NewsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed8e42",
  null
  
)

export default component.exports